var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { reducer } from "./views/Search/components/SearchContainer/SearchContainer.reducer.js";
import { combineReducers } from "redux";
import currentUserDetailsReducersMapObject from "@ane/exp-data/lib/userDetails/CurrentUserDetailsReducer";
import managementGroupSelectorReducer from "@ane/exp-ux/lib/components/ManagementGroupSelector/ManagementGroupSelector.ducks";
import getWorkspaceReducersMapObject from "@ane/exp-ux/lib/components/GetWorkspace/GetWorkspace.ducks";
import UserAccessReducersMapObject from "@ane/exp-ux/lib/components/GetUserAccess/UserAccess.reducer";
import { searchFilterReducer } from "./views/Search/components/SearchFilters/SearchFilters.reducer.js";
const moduleReducer = __spreadValues(__spreadValues(__spreadValues({
  budget: combineReducers(__spreadValues({
    search: reducer,
    searchFilters: searchFilterReducer,
    managementGroupSelector: managementGroupSelectorReducer
  }, currentUserDetailsReducersMapObject))
}, currentUserDetailsReducersMapObject), getWorkspaceReducersMapObject), UserAccessReducersMapObject);
export {
  moduleReducer as default,
  moduleReducer
};
//# sourceMappingURL=reducers.js.map
